<template>
  <AppHeaderDropdown right no-caret>
    <template  slot="header">
      
        {{ formatName($auth.user().name) }}
      

    </template>
  </AppHeaderDropdown>
</template>
<style>
.space{
  padding-left: 10px;
}
.exit-img{
  width: 15px;
  padding-left: 2px;
  padding-bottom: 2.5px;
}
</style>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import router from '@/router'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    formatName(name) {
    if (!name) return ''; // Retorna vazio se o nome não existir
    const names = name.trim().split(' ');
    if (names.length === 1) return names[0]; // Apenas um nome
    return `${names[0]} ${names[names.length - 1]}`; // Primeiro e último
  },
  }
}
</script>
